import _slicedToArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { Map } from 'immutable';
import { action, observable, runInAction } from 'mobx';
import { WorkflowCasesLayer } from '../../transportLayers/workflow-cases/WorkflowCasesLayer';
/**
 * Contains logic to determine assignee of any workflow case and decide whether it is locked.
 * Store periodically updates info about assignees so it can be used to automatically lock or unlock WF cases.
 */

export var WorkflowAssigneeObserverStore =
/*#__PURE__*/
function () {
  /**
   * Creates an observer which periodically checks assignees of given workflow cases.
   *
   * @param updateInterval in ms
   * @param onChange called, when assignees have changed
   */
  function WorkflowAssigneeObserverStore(updateInterval, onChange) {
    var _this = this;

    _classCallCheck(this, WorkflowAssigneeObserverStore);

    this.updateInterval = updateInterval;
    this.onChange = onChange;
    this.assignees = Map();
    this.isUpdating = false;
    this.isActive = false;
    this.workflowCasesLayer = new WorkflowCasesLayer();

    this.updateAssignees = function () {
      return __awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.isActive) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                runInAction(function () {
                  _this2.isUpdating = true;
                });
                _context.prev = 3;
                _context.next = 6;
                return this.workflowCasesLayer.getWFCasesAssignees(this.wfCaseIds);

              case 6:
                result = _context.sent;
                this.setAssigneesIfChanged(result);
                _context.next = 12;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](3);

              case 12:
                _context.prev = 12;
                runInAction(function () {
                  _this2.isUpdating = false;
                });
                return _context.finish(12);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 10, 12, 15]]);
      }));
    };
  }
  /**
   * Start observing.
   *
   * @param wfCaseIds
   */


  _createClass(WorkflowAssigneeObserverStore, [{
    key: "init",
    value: function init(wfCaseIds) {
      if (this.isActive) {
        this.destroy();
      }

      this.wfCaseIds = wfCaseIds;
      this.isActive = true;
      this.intervalHandle = window.setInterval(this.updateAssignees, this.updateInterval);
    }
    /**
     * Stop observing. Don't forgot to call this, when observing is no longer needed.
     */

  }, {
    key: "destroy",
    value: function destroy() {
      window.clearInterval(this.intervalHandle);
      this.isActive = false;
    }
    /**
     * Returns assignee if WF case is assigned (locked), null if it is not, undefined if it is unknown.
     * @param wfCaseId
     */

  }, {
    key: "getAssignee",
    value: function getAssignee(wfCaseId) {
      return this.assignees.get(wfCaseId);
    }
  }, {
    key: "setAssigneesIfChanged",
    value: function setAssigneesIfChanged(result) {
      // trigger MobX observable logic only if assignees truly changes
      if (result.size !== this.assignees.size) {
        this.setAssignees(result);
        return;
      }

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.assignees[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _step$value = _slicedToArray(_step.value, 2),
              caseId = _step$value[0],
              assignee = _step$value[1];

          var newAssignee = result.get(caseId);

          if (newAssignee !== assignee && (newAssignee === null || assignee === null || newAssignee.id !== assignee.id)) {
            this.setAssignees(result);
            return;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: "setAssignees",
    value: function setAssignees(newAssignees) {
      var previousAssignees = this.assignees;
      this.assignees = newAssignees; // don't call onChange on initial update

      if (previousAssignees.size !== 0 && this.onChange) {
        this.onChange(previousAssignees);
      }
    }
  }], [{
    key: "RELOAD_ON_CHANGE",
    value: function RELOAD_ON_CHANGE() {
      location.reload();
    }
  }]);

  return WorkflowAssigneeObserverStore;
}();

__decorate([observable, __metadata("design:type", Object)], WorkflowAssigneeObserverStore.prototype, "assignees", void 0);

__decorate([observable, __metadata("design:type", Object)], WorkflowAssigneeObserverStore.prototype, "isUpdating", void 0);

__decorate([observable, __metadata("design:type", Object)], WorkflowAssigneeObserverStore.prototype, "isActive", void 0);

__decorate([action, __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", void 0)], WorkflowAssigneeObserverStore.prototype, "setAssignees", null);